module.exports = __webpack_public_path__ + "img/duns-registered-cert.8af44e35.jpg";